import { render, staticRenderFns } from "./MarketplaceListComponent.vue?vue&type=template&id=99643b88"
import script from "./MarketplaceListComponent.vue?vue&type=script&lang=js"
export * from "./MarketplaceListComponent.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceListComponent.vue?vue&type=style&index=0&id=99643b88&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports